import { createSelector } from '@reduxjs/toolkit';

import { jsonQuerySelector } from './root';

export const selectJsonQueryType = createSelector(jsonQuerySelector, state => state.filters._type);
